import { useQuery } from '@tanstack/react-query';

import { AssistantApi } from '../../apis';
import { QueryKeys } from '../query-keys';

export const CONVERSATION_QUERY_KEY = [QueryKeys.ASSISTANT, 'conversation'];

const useConversation = () => {
  const query = useQuery({
    queryKey: CONVERSATION_QUERY_KEY,
    queryFn: () => AssistantApi.getConversation(),
    // The endpoint answers 404 while the assistant is turned off: no point in retrying.
    retry: false,
  });

  return {
    isLoading: query.isPending,
    isUnavailable: query.isError,
    title: query.data?.title ?? null,
    messages: query.data?.messages ?? [],
  };
};

export default useConversation;
